import { CompanyType } from 'app/constants/companyType'
import { AuditFieldsModel } from './auditFields'
import { GroupModel } from './groupModel'
import { PredefinedPackage } from './predefinedPackageModel'

export interface AggregatedCompanyDetailsModel {
  companies: Array<CompanyDetailsModel>
  activeDriversCount: number
  proActiveDriversCount: number
  companiesCount: number
}

export interface CompanyDetailsModel extends AuditFieldsModel {
  id: string
  companyName?: string
  invoiceCompanyName?: string
  isValid?: boolean
  hasDatabase?: boolean
  // Billed through a service account; set even when `tenant` is not (no rights on the account).
  isUnderServiceAccount?: boolean
  serviceAccountName?: string
  regon?: string
  nip?: string
  krs?: string
  email?: string
  notificationsEmail?: string
  contactEmail?: string
  contactCCEmail?: string
  contactPhone?: string
  licenseNumber?: string
  street?: string
  houseNumber?: string
  buildingNumber?: string
  postalCode?: string
  city?: string
  type?: CompanyType
  tenant?: CompanyDetailsModel
  tenantId?: string
  databaseId?: string
  databaseName?: string
  error?: string
  serverId?: string
  isDeleted?: boolean
  servers?: Array<string>
  serverNames?: Array<string>
  serverNamesFormatted?: string
  serverName?: string
  uniqueIdentifier?: string
  childCompanies?: Array<CompanyDetailsModel>
  lastErrorMessage?: string
  deletedDate?: any
  isActive?: boolean

  note?: string

  databaseVersion?: string

  lastSynchronizationDate?: Date
  synchronizationSource?: number

  useLocalImport?: number
  activeDriversLimits?: number
  driversCount?: number
  currentDriversCount?: number
  size?: number | null
  proDriversCount?: number
  proDriversFromPreviousMonthCount?: number
  package?: PredefinedPackage
  packageMultiplier?: number
  packageAmount?: number
  accountingOnly?: boolean
  previousUnpaidDrivers?: number

  temporary?: boolean

  groups?: Array<GroupModel>
  groupList?: Array<string>
  userRoles?: Array<RolesAssignModel>

  subscriptionExpirationDate?: any
  suspendedFrom?: any
  suspendedTo?: any
  monthlySubscription?: boolean
  suspensionDate?: any
  suspended?: boolean
  paid?: boolean
  boundedPackage?: boolean

  monthlySubscriptionDateOverride?: boolean
  paymentDaysOverride?: number

  isEwiSystem?: boolean
  discount?: boolean
  discountValue?: number

  paymentReminderDate?: any
  enablePaymentReminder?: boolean
  paymentReminderDuration?: number
  additionalPaidDrivers?: number

  manuallyEnteredUnpaidDrivers?: boolean
  unpaidDrivers?: number

  isPro?: boolean
  hasKeyProFeature?: boolean
  proFeatureDisabled?: boolean

  paymentDays?: number

  newActiveDriversLimits?: number

  newPackage?: number
  newPackageMultiplier?: number

  newPackageFrom?: any
  newPackageTo?: any
  newBoundedPackage?: boolean

  newMonthlySubscription?: boolean
  newSubscriptionExpirationDate?: any

  multipleKeys?: boolean
  multipleLogsFromKeys?: boolean

  bonusAmount?: number
  bonusMonths?: number
  bonusStartedAt?: any

  commisionEnabled?: boolean
  commisionValue?: number
  commisionMonth?: number
  commisionAmount?: number

  paidDriversInPreviousMonth?: number
  paymentNetAmount?: number
  paymentDriversCount?: number
  paymentDate?: any
  paymentCreationDate?: any
  manualPayment?: boolean
  invoiceNumber?: string
  providerInvoiceId?: number
  paymentMonths?: number

  longPaymentNetAmount?: number
  longPaymentDate?: any
  longPaymentCreationDate?: any
  longPaymentMonths?: number
  longPaid?: boolean

  activationDate?: any
  sellDate?: any

  currentDriversOverflow?: number
  currentDriversModificationDate?: any

  unpaidDriversModificationDate?: any
  previousMonthDriversAdjustmentDate?: any

  permanentlyBlocked?: boolean

  forcePaymentSave?: boolean
  timesheetModuleEnabled?: boolean
  blockTimesheetCalculation?: boolean

  department?: string
  demoTimeRemaining?: any
  demoUntil?: any
  ipAddress?: string
  running?: boolean
  demoKey?: string

  group?: string
}

export const ImportTypes = [
  { key: 0, type: 'REMOTE' },
  { key: 1, type: 'LOCAL' },
  { key: 2, type: 'AS_PARENT' },
]

export interface RolesAssignModel {
  userId: string
  roles: Array<RoleModel>
}

export interface RoleModel {
  id: string
}
